export default class GetCategoriaById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idCategoria) {
    try {
      const result = await this.#repository.getCategoriaById(idCategoria)
      return result
    } catch (error) {
      throw error
    }
  }
}
